import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import imageUrl from "../../../images/StudyCalculatorImg.webp";
const TITLE = "تحويل المعدل التراكمي إلى النظام الفرنسي";
const DESCRIPTION =
  "اكتشف كيفية تحويل معدلك الجامعي إلى النظام الفرنسي بسهولة ودقة. اعرف تفاصيل النظام الفرنسي للدرجات الجامعية.";
const KEYWORDS =
  "النظام الجامعي الفرنسي, تحويل المعدل الجامعي, نظام الدرجات الفرنسي, معدل البكالوريوس, معدل الماجستير, المعدل الجامعي, فرنسا";
const OG_URL = "https://do-calculate.com/calculator/ar/gradetofrench";
function GradeToFrench() {
  const [originalValue, setOriginalValue] = useState("");
  const [convertedValue, setConvertedValue] = useState("");
  const [conversionType, setConversionType] = useState("grade");
  const [showResult, setShowResult] = useState(false);
  const [error, setError] = useState(null);
  const gpaToFrenchGrade = (gpa) => {
    if (gpa >= 3.7 && gpa <= 4.0) {
      return "16 – 20";
    } else if (gpa >= 3.5 && gpa < 3.7) {
      return "14 – 15.9";
    } else if (gpa >= 3.0 && gpa < 3.5) {
      return "12 – 13.9";
    } else if (gpa >= 2.5 && gpa < 3.0) {
      return "10 – 11.9";
    } else if (gpa >= 2.0 && gpa < 2.5) {
      return "8 – 9.9";
    } else if (gpa >= 1.5 && gpa < 2.0) {
      return "7 – 7.9";
    } else if (gpa >= 1.0 && gpa < 1.5) {
      return "6 – 6.9";
    } else if (gpa >= 0.5 && gpa < 1.0) {
      return "5 – 5.9";
    } else if (gpa >= 0.0 && gpa < 0.5) {
      return "0 – 4.9";
    } else {
      return "مدخلات غير صالحة";
    }
  };
  const calculateGrade = (value) => {
    if (conversionType === "grade") {
      const grade = parseFloat(value);
      if (!isNaN(grade) && grade >= 0 && grade <= 100) {
        return (grade / 5).toFixed(2);
      }
    } else if (conversionType === "gpa") {
      const gpa = parseFloat(value);
      if (!isNaN(gpa) && gpa >= 0 && gpa <= 4) {
        return gpaToFrenchGrade(gpa);
      }
    }
    return "مدخلات غير صالحة";
  };
  const handleCalculateClick = () => {
    const converted = calculateGrade(originalValue);
    setConvertedValue(converted);
    setShowResult(true);
    setError(null);
  };
  const handleConversionTypeChange = (newConversionType) => {
    setConversionType(newConversionType);
    setOriginalValue("");
    setConvertedValue("");
    setShowResult(false);
    setError(null);
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  اكتشف كيفية تحويل معدلك الجامعي (مئوي أو تراكمي) إلى النظام
                  الفرنسي بسهولة ودقة. اعرف تفاصيل النظام الفرنسي للدرجات
                  الجامعية باستخدام هذه الأداة المفيدة.
                </p>
              </div>
              <br />
            </div>
            <hr />
             <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>
                    تحويل المعدل الجامعي إلى النظام الفرنسي
                  </h2>
                </div>
                <hr />
                <div className="form-group">
                  <b>
                    <label>نوع المعدل:</label>
                  </b>
                  <div>
                    <input
                      type="radio"
                      id="gradeConversion"
                      name="conversionType"
                      value="grade"
                      checked={conversionType === "grade"}
                      onChange={() => handleConversionTypeChange("grade")}
                      className="form-check-input"
                      style={{ marginLeft: "4px" }}
                    />
                    <label
                      htmlFor="gradeConversion"
                      className="form-check-label"
                    >
                      مئوي (100)
                    </label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="gpaConversion"
                      name="conversionType"
                      value="gpa"
                      checked={conversionType === "gpa"}
                      onChange={() => handleConversionTypeChange("gpa")}
                      className="form-check-input"
                      style={{ marginLeft: "4px" }}
                    />
                    <label htmlFor="gpaConversion" className="form-check-label">
                      تراكمي (4.00)
                    </label>
                  </div>
                </div>
                <br />
                <div>
                  <div className="form-group d-flex align-items-center">
                    <b>
                      <label htmlFor="originalValue">
                        {conversionType === "grade"
                          ? "المعدل المئوي:"
                          : "المعدل التراكمي:"}
                      </label>
                    </b>
                    <input
                      type="text"
                      value={originalValue}
                      id="originalValue"
                      onChange={(e) => setOriginalValue(e.target.value)}
                      className="form-control"
                      style={{ width: "200px", marginRight: "4px" }}
                    />
                  </div>
                  <div>
                    <br />
                  </div>
                </div>
                <button
                  className="btn btn-success mt-3"
                  onClick={handleCalculateClick}
                >
                  احسب                </button>
                <br />
              </div>
            </div>
            <br />
            <div className="row">
              <div className="col-sm-12 col-md-7">
                {error && (
                  <div className="alert alert-warning">
                    <b>
                      <u>Error:</u>
                    </b>{" "}
                    {error}
                  </div>
                )}
                {showResult &&  (
                  <div
                    style={{ fontSize: "15px" }}
                    className="bg-light bg-gradient text-dark"
                  >
                    <div className="p-3 bg-success bg-gradient text-white">
                      <strong>النتيجة:</strong>
                    </div>
                    <b>
                      {conversionType === "grade"
                        ? `المعدل المئوي بالنسبة للنظام الفرنسي: ${convertedValue}`
                        : `المعدل التراكمي بالنسبة للنظام الفرنسي: ${convertedValue}`}
                    </b>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">{TITLE}</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      نظام تصنيف الدرجات الجامعية في فرنسا
                    </h2>
                  </u>
                  <p>
                    في فرنسا، يتم تصنيف الدرجات على مقياس من 0 إلى 20، حيث 20 هو
                    الأفضل و0 هو الأسوأ. يمكن تقسيم الدرجات على النحو التالي:
                  </p>
                  <table >
                    <thead>
                      <tr className="bmi-header">
                        <th>الدرجة الفرنسية</th>
                        <th>المصطلحات الفرنسية المكافئة</th>
                        <th>النسبة المئوية المكافئة</th>
                        <th>المعدل التراكمي (على مقياس 4 نقاط)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>16 – 20</td>
                        <td>ممتاز</td>
                        <td>80-100%</td>
                        <td>3.7-4.0</td>
                      </tr>
                      <tr>
                        <td>14 – 15.9</td>
                        <td>جيد جدًا</td>
                        <td>70-79%</td>
                        <td>3.5-3.6</td>
                      </tr>
                      <tr>
                        <td>12 – 13.9</td>
                        <td>جيد</td>
                        <td>60-69%</td>
                        <td>3.0-3.4</td>
                      </tr>
                      <tr>
                        <td>10 – 11.9</td>
                        <td>مقبول</td>
                        <td>50-59%</td>
                        <td>2.5-2.9</td>
                      </tr>
                      <tr>
                        <td>0 – 9.9</td>
                        <td>راسب</td>
                        <td>0-49%</td>
                        <td>0-2.4</td>
                      </tr>
                    </tbody>
                  </table>
                  <p>
                    هذه المعلومات تساعد في فهم كيفية تحويل المعدلات إلى النظام
                    الفرنسي ومعرفة ما يعادلها باللغة الإنجليزية والنسبة المئوية.
                  </p>
                  <b className="text-primary">
                    <span>مثال: </span>
                    إذا كان لديك معدل تراكمي 3.0 على مقياس 4.0، يمكنك تحويله إلى
                    النظام الفرنسي باستخدام الأداة أعلاه وستحصل على النتيجة
                    المعادلة.
                  </b>
                  <p>
                    هذه الأداة مفيدة جدًا للطلاب الدوليين الذين يرغبون في متابعة
                    دراستهم في فرنسا أو التقديم على وظائف تطلب معدل دراسي معين.
                  </p>
                  <div>
                    <p>
                      تعد فرنسا من الدول المتطورة علميًا، وفيها العديد من
                      الجامعات العريقة التي يقصدها الطلاب من جميع أنحاء العالم.
                    </p>
                    <p className="alert alert-info">
                      أن في فرنسا العديد من الجامعات المصنفة عالميًا، ويمتاز
                      النظام الدراسي في الجامعات الفرنسية بالصرامة العلمية
                      والجدة في المناهج. وتعد التكاليف الدراسية في فرنسا معقولة
                      مقارنة ببقية الدول الأوروبية والولايات المتحدة الأميركية.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default GradeToFrench;
